import { Component } from '@angular/core';
import { GcmNotificationsComponent } from '@gcm/gcm-ui-angular';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { HeaderComponent } from '../header/header.component';


@Component({
    selector: 'app-gcm-app',
    imports: [GcmNotificationsComponent, HeaderComponent, SidenavComponent],
    templateUrl: './custom-gcm-app.component.html'
})
export class CustomGcmAppComponent {
  showSideNav = false;

  openSideNav() {
    this.showSideNav = !this.showSideNav;
  }
}
